import React from "react";
import MerGraph from "../MerGraph";
import renderOptions from "../../utils/renderOptions";

const defaultDatasetOptions = {
    pointRadius: 0,
    borderWidth: 3,
    fill: true,
}

const MerGraphWrapper = ({
    tabData,
    selectedMetric,
    dailyGoal,
    predictionState,
    formattedGraphData
}) => {

    let data = !tabData ? {} : {
        labels: tabData.labels,
        datasets: selectedMetric === 'mer' ? [{
            data: tabData.metrics.merData,
            label: 'MER',
            borderColor: '#66FFCC',
            yAxisID: 'y1',
            ...defaultDatasetOptions
        }] :
            selectedMetric === 'breakdown' ? [
                {
                    data: tabData.metrics.revenueData,
                    label: 'Revenue',
                    borderColor: '#66FFCC',
                    yAxisID: 'y1',
                    ...defaultDatasetOptions
                },
                {
                    data: tabData.metrics.adspendData,
                    label: 'Adspend',
                    borderColor: '#F33FFF',
                    yAxisID: 'y2',
                    ...defaultDatasetOptions
                }
            ] :
                [
                    {
                        data: tabData.metrics.merData,
                        label: 'MER',
                        borderColor: '#66FFCC',
                        yAxisID: 'y1',
                        ...defaultDatasetOptions
                    },
                    {
                        data: tabData.metrics.merPredictionData,
                        label: 'MER',
                        borderColor: '#f6f7f8',
                        yAxisID: 'y3',
                        borderWidth: 2,
                        borderDash: [10, 10],
                        ...defaultDatasetOptions
                    }
                ]
    }

    return (
        <>

            {
                // render prediction graph view
                selectedMetric === 'prediction' ? (
                    predictionState?.data ? (
                        renderGraph()
                    ) : (
                        <div className="mer-graph ready prediction-loading">
                            <p>{predictionState?.error || 'We are generating your prediction data...'}</p>
                            {!predictionState?.error && <p>Progress: {predictionState?.progress || 0}%</p>}
                        </div>
                    )
                ) :

                formattedGraphData ?  <MerGraph
                                            data={formattedGraphData}
                                            options={renderOptions(selectedMetric, formattedGraphData)}
                                            dailyGoal={dailyGoal}
                                      /> :

                    // render normal graph view
                    tabData && <MerGraph
                        data={data}
                        options={renderOptions(selectedMetric, data)}
                        dailyGoal={dailyGoal}
                    />
            }
        </>
    )

}

export default MerGraphWrapper;